import React, { useEffect, useRef, useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import SelectMoveSquaresMenu from './MoveSquaresMenu';
import { gameStatusState } from '../../globalStates/general/gameStatus';
import { selectSquareAreaState } from '../../globalStates/general/selectSquare';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import GetInfo from './InfoWindow';
import { honeycombStructureDisplayState } from '../../globalStates/general/honeycombStructureDisplay';
import { writeField } from './fieldFunction';
import WarpWindow from './Item/WarpWindow';
import { updateTotalPoint } from '../../database/updateTotalPoint';
import { useLocation } from 'react-router-dom';
import { userDataState } from '../../globalStates/general/userData';
import { userDataUpdateFlagState } from '../../globalStates/general/userDataUpdateFlag';
import { getUserData } from '../../database/getUserData';
import { auth } from '../../database/firebase';
import { useAuthState } from 'react-firebase-hooks/auth';
import { fieldDataState } from '../../globalStates/general/fieldData';
import { player1CurrentSquaresState } from '../../globalStates/general/player1CurrentSquare';
import { thisGamePointState } from '../../globalStates/general/thisGameGetPoint';
import InfoWindow from './InfoWindow';
import { gameOverDisplayState } from '../../globalStates/general/gameOver';
import { treasureChestState } from '../../globalStates/item/treasureChest';
import { levelState } from '../../globalStates/general/level';
import { backpackDisplayState } from '../../globalStates/general/backpackDisplay';
import { useItemAreaDisplayState } from '../../globalStates/item/useItemAreaDisplay';
import { useMedia } from 'use-media';
// ゲームフィールド下を全て管理
const Field = (props) => {
  const [selectAreaDisplay, setSelectAreaDisplay] = useRecoilState(selectSquareAreaState);
  // game status
  // 1: choice
  // 2: get the word or item
  // 3: use the word or item ? 4 : 1
  // 4: function for use word or use item → game complete ? end : 1
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const setHoneycombDisplay = useSetRecoilState(honeycombStructureDisplayState);
  const [userData, setUserData] = useRecoilState(userDataState);
  const [userDataUpdateFlag, setUserDataUpdateFlag] = useRecoilState(userDataUpdateFlagState);
  const [user, initialising] = useAuthState(auth);
  const fieldData = useRecoilValue(fieldDataState);
  const playerCurrentIndex = useRecoilValue(player1CurrentSquaresState);
  const setThisGamePoint = useSetRecoilState(thisGamePointState);
  const [level, setLevel] = useRecoilState(levelState);
  const [pointVius, setPointVius] = useRecoilState(treasureChestState);
  const setGameover = useSetRecoilState(gameOverDisplayState);
  const [fieldAreaDisplay, setFieldAreaDisplay] = useState("block");
  const [backpackDisplay, setBackpackDisplay] = useRecoilState(backpackDisplayState);
  const [useItemAreaDisplay, setUseItemAreaDisplay] = useRecoilState(useItemAreaDisplayState);
  const isPC = useMedia({ minWidth: '1000px' });



  useEffect(() => {
    switch (gameStatusValue) {
      case 0:
        setSelectAreaDisplay("none");
        setHoneycombDisplay("none");
        window.alert("アクセスできません。");
        window.location.replace("/");
      case 1:
        // console.log("ユーザーは進ます数を選択中です。");
        setSelectAreaDisplay("block");
        break;
      case 2:
        // console.log("ユーザーはアイテムまたはワードを入手しました。");
        break;

      case 4:
        // console.log("ユーザーはアイテムを使用します。");
        break;

      case 5:
        // console.log("ハニカム構造に当て嵌めます。");
        const htmlDom = document.querySelector('html');
        htmlDom.style.overflowY = "hidden";//スクロールを禁止
        setSelectAreaDisplay("none");
        setFieldAreaDisplay("none");
        setBackpackDisplay("block");
        setHoneycombDisplay("block");
        setUseItemAreaDisplay("none");
        break;
      case 6:
        // console.log("ゲームをクリアしました。");
        let clearPoint;
        if (level === "easy")
          clearPoint = 3;
        else if (level === "normal")
          clearPoint = 5;
        else if (level === "hard")
          clearPoint = 10;
        else if (level === "self")
          clearPoint = 5;

        else
          return;

        const restCnt = props.cnt;
        const thisGamePoint = Math.floor((clearPoint + restCnt) * pointVius);
        //各難易度クリア時の獲得ポイント + 残りの手数 + アイテムによる増加分
        const totalPoint = thisGamePoint + userData.totalPoint;
        setThisGamePoint(thisGamePoint);

        if (user) {
          new Promise(() => {
            updateTotalPoint(totalPoint)
              .then(() => {
                // stateのアップデート
                getUserData().then((data) => {
                  setUserData(data);
                });
              })
              .then(() => {
                setGameStatusValue(7);
              })
          })
        }

        break;

      case 7:
        return;
      case 8:
        // gameover
        setGameover("display");
        break;

      default:
        console.error("Wrong game state.");
    }
  }, [gameStatusValue]);
  // style
  let gridArea;
  if (isPC) {
    gridArea = css`
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(52, 52, 52, 0.5);
    display: flex;
    align-content: flex-start;
    overflow-y: scroll;
    flex-basis: 70vw;
    flex-wrap: wrap;
    height: calc(100vh - 175px);

    // 次に進む予定のマスのCSS
    @keyframes pulseMotion {
      0% {
        transform: translate(-50%, -50%) scale(1, 1);
        background-color: rgba(130, 213, 255, 0.4)
      }
      100% {
        transform: translate(-50%, -50%) scale(2, 2);
        background-color: rgba(130, 213, 255, 0)
      }
    }

    #nextGrid {
      overflow: hidden;
      &:after {
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        border-radius: 50%;
        transition: opacity linear 0.4s;
        content: '';
        animation: pulseMotion 1.3s linear infinite;
      }
    }

    div {
      font-family: 'Exo 2';
      border-radius: 15px;
      padding: 10px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
      margin-top: 20px;
      width: 100px;
      height: 100px;
      border: 1px solid black;
      span {
        position: absolute;
        top: 20px;
        color: blue;
      }
    }
  `;
  } else {
    gridArea = css`
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(52, 52, 52, 0.5);
    /* z-index: -1; */
    height: calc(100vh - 50px - 0.5em);
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    overflow-y: scroll;
    flex-basis: 70vw;
    div {
      margin-left: 3px;
      margin-top: 3px;
      overflow-y: scroll;
      font-size: 0.5em;
      font-family: 'Exo 2';
      border-radius: 15px;
      padding: 5px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      border: 0.8px solid black;
      span {
        position: absolute;
        top: 20px;
        color: blue;
      }
    }
  `;
  }
  const gridAreaWrapForSmartphone = css`
    display: flex;

  `
  const fieldArea = css`
    display: ${fieldAreaDisplay};
  `;


  const grid_len = props.field_data.length;
  let draw_contents = writeField(props.field_data, false, isPC);
  return (
    <>
      <div css={fieldArea}>

        {
          // isPC ? <>
          //   <SelectMoveSquaresMenu selectAreaDisplay={selectAreaDisplay} gridLen={grid_len} fieldData={props.field_data} cnt={props.cnt} />

          //   <InfoWindow />
          //   <div css={gridArea}>

          //     {draw_contents}
          //   </div>
          // </> :
          <>

            <div css={gridAreaWrapForSmartphone}>
              <div css={gridArea}>

                {draw_contents}
              </div>
              <div style={{ width: "40vw", height: '10px' }}>
                <SelectMoveSquaresMenu selectAreaDisplay={selectAreaDisplay} gridLen={grid_len} fieldData={props.field_data} cnt={props.cnt} />
                <InfoWindow />
              </div>
            </div>
          </>
        }
      </div>
    </>
  )
}

export default Field
